import { Injectable, ElementRef } from '@angular/core';
import { HttpInterceptor, HttpHandler, HttpRequest, HttpEvent, HttpClient } from '@angular/common/http';
import { CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route, Resolve, Router, NavigationEnd } from '@angular/router';
import { ApiService, SharedService } from './common/service';
import { IDataCompanyLayout, IDataDirectopubConfig } from './common/interface';
import { LocalStorageService } from 'angular-2-local-storage';

import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { AppConfig } from './app.config';
import * as CryptoJS from 'crypto-js';
import { EntitySetting } from './common/classes';
import { URLSearchParams } from '@angular/http';
import { APIResolver } from './common/resolver';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { moment } from 'ngx-bootstrap/chronos/test/chain';
import { ApiEnv } from './common/enum';

declare const jQuery: any;

// tslint:disable:max-classes-per-file
// tslint:disable: one-variable-per-declaration

export interface InternalStateType {
  [key: string]: any;
}

@Injectable()
export class AppState {
  public _state: InternalStateType = {};

  // tslint:disable-next-line: no-empty
  constructor() { }

  // already return a clone of the current state
  get state() {
    return this._state = this._clone(this._state);
  }
  // never allow mutation
  set state(value) {
    throw new Error('do not mutate the `.state` directly');
  }

  public get(prop?: any) {
    // use our state getter for the clone
    const state = this.state;
    return state.hasOwnProperty(prop) ? state[prop] : state;
  }

  public set(prop: string, value: any) {
    // internally mutate our state
    return this._state[prop] = value;
  }

  private _clone(object: InternalStateType) {
    // simple object clone
    return JSON.parse(JSON.stringify(object));
  }
}

// tslint:disable-next-line:max-classes-per-file
@Injectable()
export class AppCanLoad implements CanLoad, CanActivateChild {
  public appConfig;

  constructor(
    private http: HttpClient,
    private router: Router,
    private api: ApiService,
    private shared: SharedService,
    private storageService: LocalStorageService,
    private translate: TranslateService,
    appConfig: AppConfig) {
    this.appConfig = appConfig.getConfig();
    window.addEventListener('storage', (e: StorageEvent) => {
      if (e.isTrusted && e.key === 'debug-layout') {
        this._handler();
      }
    }, false);
  }
  public canLoad(route: Route): boolean | Observable<boolean> | Promise<boolean> { return this._handler(); }
  public canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> | Promise<boolean> { return this._handler(); }

  private _handler(): Promise<boolean> {
    let promise: Promise<boolean> = Observable.of(true).toPromise();
    if (!this.shared.layout) {
      promise = this.api.get('company/layout').toPromise().then((r) => {
        // tslint:disable-next-line:one-variable-per-declaration
        this.shared.environment = _.get(r, '_metadata.env', ApiEnv.Production);
        const data = r.data, layoutData: IDataCompanyLayout = data[0];
        if (!!layoutData) {
          this.shared.layout = layoutData;
          // debugger
        } else {
          this.shared.layout = this.appConfig.default_layout;
        }
        const entity = new EntitySetting('company', this.shared.layout.uid);
        return this.api.get('entitymanager', null, new URLSearchParams(`api=entity&key=${entity.getKey('env_directopub')}`))
          .map((er) => er.data[0] ? er.data[0].entity : {})
          .toPromise()
          .then((directopubConfig) => {
            try {
              this.shared.directopubConfig = directopubConfig || JSON.parse(this.shared.layout.setting_last_collected_note);
            } catch (error) {
              this.shared.directopubConfig = {} as IDataDirectopubConfig;
            }

            const language = this.shared.directopubConfig.language || this.appConfig.languages;
            // if (_.isEmpty(language)) { language = this.appConfig.languages; }
            const languageOverload = language.filter((l) => !_.isString(l) && !!l.custom).map((l: any) => l.key);
            const languagePlainList = language.map((l) => _.isString(l) ? l : l.key);
            this.translate.addLangs(languagePlainList); // enabled translations
            this.translate.setDefaultLang(languagePlainList[0]);
            console.debug(`adding languages ${JSON.stringify(languagePlainList)} current lang "${languagePlainList[0]}"`);

            const useLanguage = (lang) => this.shared.language = lang;
            const onChangeLang = (lang: string) => {              
              getGridLang(lang)
              // moment.locale(lang.toLowerCase()); // update moment locale
              if (languageOverload.indexOf(lang) > -1) {
                this.http.get(`/assets/i18n/custom/${this.shared.layout.uid}.${lang}.json?${Date.now()}`, { responseType: 'json' })
                  .subscribe(
                    (i18n) => {
                      // console.log('I18N CUSTOM', i18n)
                      // this.translate.setTranslation(lang, JSON.parse(JSON.stringify(i18n)), true);

                      const fnMergeObjRecursively = (val: any, src: any): any => _.isObject(val) && _.isObject(src) ? _.assignWith(val, src, fnMergeObjRecursively) : (_.isUndefined(src) ? val : src);
                      this.translate.setTranslation(lang, _.assignWith({}, this.translate.translations[lang], i18n, fnMergeObjRecursively));
                      console.debug(`language custom loaded "${_.cloneDeep(lang)}"`, _.cloneDeep(this.translate.translations[lang]));
                      // console.debug(`language custom loaded "${_.cloneDeep(lang)}"`);
                    },
                    (e) => console.warn('no custom translations found', e),
                    () => useLanguage(lang)
                  );
              } else {
                useLanguage(lang) 
              }
            };

            const getGridLang = (lang: string) => {
              this.http.get(`/assets/i18n/ag-grid-${lang}.json?${Date.now()}`, { responseType: 'json' }).subscribe(
                (data) => {                  
                  this.shared.agGridLanguage = data
                },
                (e) => console.warn('no grid translations found', e),
              )
            }

            this.translate.onLangChange.skip(1).subscribe((e: LangChangeEvent) => {
              onChangeLang(e.lang);             
            }, (e) => console.debug('error translation >>> ', e));

            console.debug(`language verified: "${_.cloneDeep(this.shared.language)}"`);
            onChangeLang(this.shared.language);

            // loading google tag manager library
            const { gtm, app } = this.shared.directopubConfig;
            if (gtm && gtm.id) {
              const gtmScript = `<!-- Google Tag Manager -->
                <script>(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
                    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
                  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
                  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
                })(window,document,'script','dataLayer','${gtm.id}');</script>
                <!-- End Google Tag Manager -->`;
                          
              const gtmScript2 = `<!-- Google Tag Manager (noscript) -->
                <noscript><iframe src="https://www.googletagmanager.com/ns.html?id=${gtm.id}"
                height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>
                <!-- End Google Tag Manager (noscript) -->`

              // window['_onGTMLoaded'] = () => { };
              jQuery('head').append(gtmScript);
              jQuery('body').prepend(gtmScript2);
            }

            // added app Styles
            if (app && _.isObject(app.style)) {
              const cssText = _.reduce(app.style,
                (r, v, k) => r.concat(
                  `${k.replace(/[A-Z]/, (m) => '-' + m.toLowerCase())}: ${_.isNumber(v) ? `${v}px` : v} !important`), []
              )
                .join(';');
              if (app.style.fontFamily) {
                const i = setInterval(() => {
                  const { fontFamily } = app.style
                  const selectors = [
                    '.btn', 'campaigns-targeting-advanced-search table.table-search'
                  ].map((v) => `${v}:not([style*="${fontFamily.replace(/[^\s\w]/g, '')}"])`)
                  const $nodes = jQuery(`app[version="${VERSION.full}"]`).find(selectors.join(', '));
                  if ($nodes.length > 0) { $nodes.css({ fontFamily }); }
                  // jQuery(`app[version="${VERSION.full}"]`).find(selectors.join(', ')).css({ fontFamily });
                }, 1000);
              }
              // debugger
              jQuery(`app[version="${VERSION.full}"]`).css({ cssText });
            }

            return this.shared.loadGuestUserSession().then(() => true);
          });
      });
    }
    return promise
      .then((r) => {
        const layout$ = Observable.of('production' !== ENV && localStorage.getItem('debug-layout') ? localStorage.getItem('debug-layout') : this.shared.layout.layout);
        const entity = new EntitySetting('company', this.shared.layout.uid);
        return layout$
          .toPromise()
          .then((layout) => {
            document.title = this.shared.layout.company_name || 'App';
            this.storageService.set('company-uid', this.shared.layout.uid);
            this.shared.loadAppIcons();

            // tslint:disable-next-line:curly
            if (jQuery('head').find(`[data-custom-css="${layout}"]`).length === 0) {
              // removing existing style after few seconds
              const $el2rem = jQuery('head>link[data-custom-css]');
              setTimeout(() => $el2rem.remove(), 1000);

              jQuery('head').append(
                jQuery('<link rel="stylesheet" type="text/css" />')
                  .attr('data-custom-css', layout)
                  .attr('href', `/style_${layout}.css?v${VERSION.full}`)
              );
            }
            return true;
          });
      });
  }

}

@Injectable()
export class AppHttpRequestInterceptor implements HttpInterceptor {

  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const modReq = req.clone({
      headers: (() => {
        let headers = req.headers;
        if (/^\/api\//.test(req.url)) {
          headers = headers.set('App-Version', VERSION.full).set('App-Name', 'DirectToPub');
          if (/^\/api\/ext\//.test(req.url)) {
            const account = _.pick(SharedService.getInstance().account || {}, ['company_id', 'id', 'role', 'timezone_id']);
            const { iterations, iv, passphrase, salt, ivHex, saltHex } = SharedService.getInstance().s3cK3y;
            const key = CryptoJS.PBKDF2(passphrase, salt, { hasher: CryptoJS.algo.SHA256, keySize: 64 / 8, iterations });
            const encrypted = CryptoJS.AES.encrypt(JSON.stringify(account), key, { iv });
            // headers.set('App-Session', encrypted.ciphertext.toString(CryptoJS.enc.Base64));
            headers = headers.set('App-Session', CryptoJS.enc.Base64.stringify(encrypted.ciphertext))
              .set('App-Session-Opts', JSON.stringify([ivHex, saltHex]));

            // encryption 
            const api = req.url.replace(/^\/api\/ext\/([-\w]+)$/, (m, m1) => {
              return m1;
            });
            switch (api) {
              case 'guest-session-mgr':
                if (_.isObject(req.body)) {
                  _.mapValues(req.body, (v, f) => {
                    v = CryptoJS.AES.encrypt(JSON.stringify(v), key, { iv });
                    req.body[f] = CryptoJS.enc.Base64.stringify(v.ciphertext);
                  });
                }
                break;
            }



          }
        }
        return headers;
      })(),
      url: /^\/api\//.test(req.url) ? req.url : req.url.concat((req.url.indexOf('?') > -1 ? '&' : '?'), `${VERSION.full}`),
    });
    return next.handle(modReq);
  }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/app.service.ts